function resultArrayToMbti(resultArray) {
  const mbtiTypes = ['I', 'E', 'S', 'N', 'F', 'T', 'J', 'P'];
  return resultArray.map((value, index) => (value[0] > value[1] ? mbtiTypes[index * 2] : mbtiTypes[index * 2 + 1])).join('');
}

export default resultArrayToMbti;